import React from 'react'

import { Form, Col, Button } from '_zari/core'

import { HistorialComprasModal } from 'sharedComponents/modals'
import { Select2Proveedor, Select2Cliente } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { OrigenesContabilidadConstant, TiposFormularioRecordarConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

import * as SocioCrud from 'services/socio.service'
import * as FormulariosGuardarService from 'services/formulariosRecordar.service'

const SocioFormGroup = ({ iError, iTouched, fIsSubmitting, iValue, values, setValues, vOrigen, condicionPagoRef }) => {
  const [mostrarHistorialCompras, setMostrarHistorialCompras] = React.useState(false)

  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values._idSocio = pickedMember.value
      values.codigoSocio = data.codigo
      values.documentoSocio = data.numeroDocumento
      values.nombreSocio = data.razonSocial
      values.tipoDocumentoSocio = data.tipoDocumento

      if (vOrigen === OrigenesContabilidadConstant.COMPRAS) {
        FormulariosGuardarService.get(pickedMember.value, TiposFormularioRecordarConstant.NUEVOASIENTO_OGCOMPRA).then(({ data: data2 }) => {
          values.moneda = data2.moneda || ''
          values.tipoDocumento = data2.tipoDocumento || '01'
          setValues(values)

          condicionPagoRef.current = data2.condicionPago || ''

          KeyEventUtil.leaveOnKeyEvent('inputselect-glosa')
        })
      } else {
        values.moneda = data.moneda || ''
        setValues(values)

        KeyEventUtil.leaveOnKeyEvent('inputselect-glosa')
      }
    })
  }

  const onCreate = React.useCallback(
    (socioCreado, closeModal) => {
      values._idSocio = socioCreado._id
      values.codigoSocio = socioCreado.codigo
      values.documentoSocio = socioCreado.numeroDocumento
      values.nombreSocio = socioCreado.razonSocial
      values.tipoDocumentoSocio = socioCreado.tipoDocumento

      setValues(values)
      closeModal()
    },
    [values, setValues]
  )

  const clickClear = React.useCallback(() => {
    values._idSocio = ''
    values.codigoSocio = ''
    values.documentoSocio = ''
    values.nombreSocio = ''
    values.tipoDocumentoSocio = ''

    setValues(values)
    KeyEventUtil.leaveOnKeyEvent('codigoRucSelect')
  }, [setValues, values])

  const clickHistorial = React.useCallback(() => {
    setMostrarHistorialCompras(true)
  }, [])

  const appendButon = React.useMemo(() => {
    return (
      <Button outline onClick={clickHistorial}>
        H
      </Button>
    )
  }, [clickHistorial])

  return (
    <>
      <Form.Group>
        <Form.Label text='RUC' htmlFor='input-codigoRucSocio' md={2} alignRightAt='md' />
        <Col md={10}>
          {iValue ? (
            <ClearInputGroup  
              id='codigoRucSocio'
              iValue={`${values.documentoSocio} - ${values.nombreSocio}`}
              clickClear={clickClear}
              append={appendButon}
            />
          ) : (
            <>
              {vOrigen === OrigenesContabilidadConstant.VENTAS ? (
                <Select2Cliente disabled={fIsSubmitting} id='codigoRucSelect' onChange={onChangeSocioHandler} showNewButton onCreate={onCreate} />
              ) : (
                <Select2Proveedor disabled={fIsSubmitting} id='codigoRucSelect' onChange={onChangeSocioHandler} showNewButton onCreate={onCreate} />
              )}
            </>
          )}
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarHistorialCompras && (
        <HistorialComprasModal show={mostrarHistorialCompras} handleClose={() => setMostrarHistorialCompras(false)} idSocio={iValue} />
      )}
    </>
  )
}

export default React.memo(SocioFormGroup)
